/**
 * alert dialog
 */

import React from "react";
import makeStyles from '@mui/styles/makeStyles';
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
  Box,
} from "@mui/material";
import Card from 'components/card';
import Icon from 'components/icon';

const useStyles = makeStyles(theme => ({
  root: {
    minWidth: theme.spacing(40),
    backgroundColor: 'transparent',
  },
  titleIcon: {
    marginRight: theme.spacing.dialogTitleIconMargin,
  },
  actionButton: {
    minWidth: theme.spacing(10),
  }
}));

export default function AlertDialog(props) {
  const {
    open,
    ok,
    okText : okTextProp,
    title,
    titleIcon,
    titleStyle,
    text,
    content,
    ...rest
  } = props;
  const classes = useStyles();
  const okText = okTextProp || "OK";

  return (
    <Dialog
      open={open}
      onClose={ok}
      classes={{paper: classes.root}}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      data-testid={props['data-testid']}
      {...rest}
    >
      <Card
        titleStyle={titleStyle || "dark"}
        title={title && <>
          <Icon className={classes.titleIcon} type={titleIcon ? titleIcon : 'warning'}/>
          {title}
        </>}
        id="alert-dialog-title"
      >        
        {(text || content) && (
          <Box>
            <DialogContent className={classes.content}>
              
              {text &&
              <DialogContentText 
                id="alert-dialog-description"
                component="div"
                sx={{ mb: 0 }}
              >
                {text}
              </DialogContentText>}

              {content}

            </DialogContent>
          </Box>
        )}
        <DialogActions>
          <Button 
            className={classes.actionButton} 
            onClick={ok} 
            color="primary" 
            autoFocus={true}            
          >
            {okText}
          </Button>
        </DialogActions>
      </Card>
    </Dialog>
  );
}